import styles from '../styles/LoginForm.module.scss';
import logo from '../assets/logo.png';
import entraLogo from '../assets/microsoft-entra-icon.png';
import { useLocalization } from '@progress/kendo-react-intl';
import { useEffect, useState } from 'react';
import { useLoginFormValidator } from '../components/login/customHooks/useLoginFormValidator';
import clsx from 'clsx';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Notification, NotificationGroup } from '@progress/kendo-react-notification';
import { Fade } from '@progress/kendo-react-animation';
import { loadingPanel } from '../components/LoadingPanel';
import { Switch } from '@progress/kendo-react-inputs';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { AccessToken } from '../config/AccessToken';



export const LoginPage = ({ handleLogin = () => { } }) => {

  const SERVER_URL = process.env.REACT_APP_SERVER_URL;

  const localizationService = useLocalization()
  const navigate = useNavigate()
  let languageId = localStorage.getItem('languageId');
  const [instance, accessTokenRequest] = AccessToken();


  const [loading, setLoading] = useState<boolean>(false);
  const [visible, setVisible] = useState<boolean>(false);
  const [message, setMessage] = useState<any>('');
  const [imageLogo, setImageLogo] = useState<any>(null);

  const [form, setForm] = useState({
    username: "",
    password: "",
    //email: "",
    //confirmPassword: "",
  });

  const { errors, validateForm, onBlurField } = useLoginFormValidator(form);

  const [switchADLogin, setSwitchADLogin] = useState<boolean>(false);

  const onUpdateField = (e: any) => {
    const field = e.target.name as keyof typeof errors;
    const nextFormState = {
      ...form,
      [field]: e.target.value,
    };
    setForm(nextFormState);
    if (errors[field].dirty)
      validateForm({
        form: nextFormState,
        errors,
        field,
      });
  };

  const onSubmitForm = async(e: any) => {
    e.preventDefault();
    const { isValid } = validateForm({ form, errors, forceTouchErrors: true });
    if (!isValid) return;
    
    setLoading(true)

    // call API 
    const params = {
      username: form.username,
      password: form.password,
    };

    try {
      await axios.post(`${SERVER_URL}/account/login`,  params)
        .then(function (response) {

          let userType:any = response?.data?.data?.userType
          let type:any = response?.data?.data?.type
          
          sessionStorage.setItem("accessToken", response?.data?.data?.token);
          localStorage.setItem("username", response?.data?.data?.username);          
          localStorage.setItem("email", response?.data?.data?.email);          
          
          localStorage.setItem("type", type);          
          localStorage.setItem("userType", userType);          
          if(userType == 'GuestSynchro'){
            navigate('/home/dashboard/synchro')
          }else if(response?.data?.data?.username == 'azure'){
              navigate('/home/azure_map')
          }else{
              navigate('/home/dashboard')            
          }
          setLoading(false)
        })
        .catch(function (error) {
          let message = error?.response?.data?.errorMessage ?? error?.response?.statusText
          let code = error?.response?.status
          if(code == 500 && message!.includes('unauthorized')){
            setVisible(true)
            setMessage(message)
            setTimeout(() => {
              setVisible(false)
            },10000)
          }else if(message!.includes(`User doesn't have an email`)){
            const userWithNoEmail = localizationService.toLanguageString('login_error.user_with_no_email', 'NOT FOUND')
            setVisible(true)
            setMessage(userWithNoEmail)
            setTimeout(() => {
              setVisible(false)
            },10000)
          }
          setLoading(false)
        });
      
    } catch (error:any) {
      console.log(error);
      setVisible(false)
    }
  };

  const toggleDialog = () => {
    setVisible(!visible);
  };

  const handleToggleSwitch = () => {
    setSwitchADLogin(!switchADLogin);
  }

  const getImageLogo = async () => {    
    axios.get(`${SERVER_URL}/account/logo`)
    .then((res) => {
        const image =  `data:image/png;base64, ${res?.data?.data.image}`
        setImageLogo(image);
    }).catch(() => {
        
    });
  }

  useEffect(() => {
      getImageLogo();
  }, [])

  return (
    <div className={styles.form}>
      {loading && loadingPanel}
      <img src={logo} className={styles.logo} />
      <h1 className={styles.textLocator}>{localizationService.toLanguageString('title', 'NOT FOUND')}</h1>
      <img src={imageLogo} style={{margin: '10px auto', textAlign: 'center', display: 'block'}} />

      { !switchADLogin ?
        <>
          <form onSubmit={onSubmitForm}>
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Username</label>
              <input
                className={clsx(
                  styles.formField,
                  errors.username.dirty && errors.username.error && styles.formFieldError
                )}
                type="text"
                aria-label="Username field"
                name="username"
                value={form.username}
                onChange={onUpdateField}
                onBlur={onBlurField}
              />
              {errors.username.dirty && errors.username.error ? (
                <p className={styles.formFieldErrorMessage}>{errors.username.message}</p>
              ) : null}
            </div>
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Password</label>
              <input
                className={clsx(
                  styles.formField,
                  errors.password.dirty &&
                  errors.password.error &&
                  styles.formFieldError
                )}
                type="password"
                aria-label="Password field"
                name="password"
                value={form.password}
                onChange={onUpdateField}
                onBlur={onBlurField}
              />
              {errors.password.dirty && errors.password.error ? (
                <p className={styles.formFieldErrorMessage}>
                  {errors.password.message}
                </p>
              ) : null}
            </div>
            {/*<div className={styles.formGroup}>
              <label className={styles.formLabel}>Confirm Password</label>
              <input
                className={clsx(
                  styles.formField,
                  errors.confirmPassword.dirty &&
                  errors.confirmPassword.error &&
                  styles.formFieldError
                )}
                type="password"
                aria-label="Confirm password field"
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={onUpdateField}
                onBlur={onBlurField}
              />
              {errors.confirmPassword.dirty && errors.confirmPassword.error ? (
                <p className={styles.formFieldErrorMessage}>
                  {errors.confirmPassword.message}
                </p>
              ) : null}
            </div>*/}
            <div className={styles.formActions}>
              <button className={styles.formSubmitBtn} type="submit">
                {localizationService.toLanguageString('login', 'NOT FOUND')}
              </button>
            </div>
          </form>
        </>
        :
          <div className={styles.entraActions} style={{marginTop: '50px'}}>
            {/*Entra Login */}
            <img src={entraLogo} width="48" height="48" />
            <a style={{ marginLeft: '20px', fontSize: 'large' }}>Microsoft Entra ID</a>
            <button type={'submit'} onClick={() => handleLogin()} className={styles.signButton}>
              {localizationService.toLanguageString('login', 'NOT FOUND')}
            </button>
          </div>
        }
        <div style={{display:'inline-flex'}}>
          { !switchADLogin ?
            <p style={{ marginRight: '20px'}}>{localizationService.toLanguageString('login_type.switch_to_sso', 'NOT FOUND')}:</p>
          :
            <p style={{ marginRight: '20px'}}>{localizationService.toLanguageString('login_type.switch_to_static', 'NOT FOUND')}:</p>
          }

          <Switch 
            //className={styles.switchButton}             
            className={'k-switch'}             
            onChange={handleToggleSwitch} 
            checked={switchADLogin} 
          />
        </div>
        <NotificationGroup
          style={{
              top: 0, 
              right: 0, 
              alignItems: 'flex-end'
              //flexWrap: "wrap-reverse",
          }}
        >
        <Fade enter={true} exit={true}>
            {visible && (
                <Notification
                    type={{ style: "error", icon: true }}
                    closable={true}
                    onClose={() => setVisible(false)}
                >
                    <span>{message}</span>
                </Notification>
            )}
        </Fade>
        </NotificationGroup>      
    </div>
  )
}